import { FC } from 'react'
import { RouteComponentProps } from '@reach/router'
import { BallotList } from './BallotList'

export const BallotContainer: FC<RouteComponentProps> = () => {
  return <BallotList />
}
